export enum AuthorizationTypes {
  STARTPAGE_ITEM = 'startpageitem',
  TICKET_TAB = 'tickettab'
}
